module.exports = __webpack_public_path__ + "img/task-5.20e8aa49.png";